import React from 'react';

import WithConfiguration from '@domain/layout/with-configuration';

import { ElearningWpRemoteFlowProvider } from './ewr-flow-context';

interface ElearningWpRemoteLayoutProps {
  children: React.ReactNode;
}

function ElearningWpRemoteLayout({ children }: ElearningWpRemoteLayoutProps) {
  return (
    <WithConfiguration>
      <ElearningWpRemoteFlowProvider>{children}</ElearningWpRemoteFlowProvider>
    </WithConfiguration>
  );
}

export default ElearningWpRemoteLayout;
